"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContrastTheme = void 0;
function isContrastTheme(theme) {
    return typeof theme.toggleContrast === 'function';
}
exports.isContrastTheme = isContrastTheme;
